import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";
import { useTranslation } from "react-i18next";

export function JigsoPromotion() {
  const { t } = useTranslation();
  return (
    <Card className="shadow-xl bg-gradient-to-r from-primary/10 via-accent/10 to-primary/10 border-primary/20 mb-12">
      <CardContent className="p-8">
        <div className="flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1 space-y-4">
            <div className="flex items-center gap-3">
              <img
                src="/lovable-uploads/822c9934-bc7f-4f51-afef-cd4280c5d405.png"
                alt="Jigso logo"
                className="w-8 h-8 rounded-lg"
              />
              <h2 className="text-2xl font-bold">{t('homepage.jigsoPromotion.title')}</h2>
            </div>
            <p className="text-lg text-muted-foreground">
              {t('homepage.jigsoPromotion.subtitle')}
            </p>
            <div className="flex flex-wrap gap-2">
              <Badge>{t('homepage.jigsoPromotion.aiPowered')}</Badge>
              <Badge>{t('homepage.jigsoPromotion.enterpriseSecurity')}</Badge>
              <Badge>{t('homepage.jigsoPromotion.realTimeAnalytics')}</Badge>
              <Badge>{t('homepage.jigsoPromotion.customIntegrations')}</Badge>
            </div>
          </div>
          <div className="flex flex-col gap-3">
            <Button asChild className="bg-primary hover:bg-primary/90">
              <a href="https://jigso.com" target="_blank" rel="noopener noreferrer">
                <ExternalLink className="w-4 h-4 mr-2" />
                {t('homepage.jigsoPromotion.cta')}
              </a>
            </Button>
            <Button variant="outline" asChild>
              <a href="https://jigso.com/contact" target="_blank" rel="noopener noreferrer">
                {t('homepage.jigsoPromotion.cta2')}
              </a>
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
} 